import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { FibonacciNumbers, Fibonacci } from '../../components/examples/';
export const _frontmatter = {
  "Title": "Fibonacci"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "fibonacci-sequence"
    }}>{`Fibonacci sequence`}</h1>
    <p>{`Both of these examples are inspired by the Fibonacci sequence, where:`}</p>
    <ul>
      <li parentName="ul">{`F`}<sub>{`0`}</sub>{` = 0,`}</li>
      <li parentName="ul">{`F`}<sub>{`1`}</sub>{` = 1,`}</li>
      <li parentName="ul">{`F`}<sub>{`n`}</sub>{` = F`}<sub>{`n - 1`}</sub>{` + F`}<sub>{`n - 2`}</sub>{` for each n > 2.`}</li>
    </ul>
    <p>{`0, 1, 1, 2, 3, 5, 8, 13, 21, 34, ...`}</p>
    <FibonacciNumbers mdxType="FibonacciNumbers" />
    <p>{`The corresponding `}<inlineCode parentName="p">{`udpateData`}</inlineCode>{` function is as follows:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`function updateData({ data, tick }) {
  if (tick === 0) {
    return [0];
  }
  if (tick === 1) {
    return [0, 1];
  }
  const lastNumber = data[tick - 1] + data[tick - 2];
  return [...data, lastNumber];
}
`}</code></pre>
    <p>{`F`}<sub>{`n`}</sub>{` / F`}<sub>{`n-1`}</sub>{` converges to φ, the golden ratio - (1 - √5) / 2.`}</p>
    <p>{`Because of this convergence, the Fibonacci sequence is sometimes associated with spirals.
We could:`}</p>
    <ul>
      <li parentName="ul">{`draw a square of side F`}<sub>{`n`}</sub>{`, then`}</li>
      <li parentName="ul">{`draw a square of side F`}<sub>{`n+1`}</sub>{` to its right, then`}</li>
      <li parentName="ul">{`draw a square of side F`}<sub>{`n+2`}</sub>{` below these two squares, then`}</li>
      <li parentName="ul">{`draw a square of side F`}<sub>{`n+3`}</sub>{` to the left of these squares, then`}</li>
      <li parentName="ul">{`a square of side F`}<sub>{`n+4`}</sub>{` above,
etc, etc.`}</li>
    </ul>
    <p>{`and by linking their corners, obtain a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Golden_spiral"
      }}>{`Golden spiral`}</a>{`.`}</p>
    <p>{`But we can also draw a Golden Spiral without even needing to initiate or update data.`}</p>
    <p>{`We can start from a rectangle φ `}{`*`}{` k by k rectangle, divide its longer side by φ, draw that square, and keep on dividing the remaining rectangle.
We'll have squares of same proportions and can also draw a similar spiral.`}</p>
    <Fibonacci mdxType="Fibonacci" />
    <p>{`All we need is the number of steps we want to go (tick) and a Frame to render the squares and spiral.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const FibonacciSpiral = () => (
  <Model initialParams={{ size: 500 }} delay={100} maxTime={20}>
    <FibonacciSpiralFrame />
  </Model>
);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      